const SET_LIST = (state, obj) => {
  state.list = obj
}

const SET_PAYER_GROUP = (state, obj) => {
  state.payerGroup = obj
}

const UPDATE_VALUES = (state, obj) => {
  Object.assign(state.payerGroup, obj)
}

const SET_ERRORS = (state, obj) => {
  state.errors = {
    'infos': Object.keys(obj).reduce((acc, key) => {
      if (!key.match(/\./)) {
        return acc.concat(obj[key])
      }
      return acc
    }, []),
    'taxLimit': Object.keys(obj).reduce((acc, key) => {
      if (key.match('limits.')) {
        return acc.concat(obj[key])
      }
      return acc
    }, [])
  }
}

const RESET_ERRORS = (state) => {
  state.errors = state.initialErrors
}

export default {
  SET_LIST,
  SET_PAYER_GROUP,
  UPDATE_VALUES,
  SET_ERRORS,
  RESET_ERRORS
}



// WEBPACK FOOTER //
// ./src/features/clients/store/payer_groups/mutations.js